import React from "react"
import {
  Container,
  Heading,
  Box,
  Text,
  Image,
  Grid,
} from "@theme-ui/components"
import { useEffect, useState } from "react"
import ArrowPrimary from "../images/list-arrow-black.svg"
import ArrowWhite from "../images/list-arrow-white.svg"
import { useBreakpointIndex } from "@theme-ui/match-media"
import { useColorMode } from "theme-ui"
import { color } from "framer-motion"
const ListCollection = ({ block }) => {
  const colorMode = useColorMode()
  const [isDark, setIsDark] = useState(false)
  useEffect(() => {
    colorMode[0] === "dark" ? setIsDark(true) : setIsDark(false)
  }, [colorMode[0]])

  console.log(block)
  const bpIndex = useBreakpointIndex()
  return (
    <Container
      sx={{
        color: "dark",
        mt: [4, 4, 4, 7],
        p: [3, 4, 4, 3],
        fontFamily: "mono",
        maxWidth: ["90%", "90%", "1380px", "1380px"],
        backgroundColor: block.dark ? "light" : "dark",
        borderRadius: "80px",
      }}
    >
      <Grid columns={[1, 1, "1fr 2fr"]} sx={{ p: 3 }}>
        <Box>
          <Text
            as="p"
            sx={{
              color: block.dark ? "dark" : "light",
              borderColor: block.dark ? "dark" : "light",
            }}
            variant="kicker"
          >
            {block.kicker}
          </Text>
        </Box>
        <Box
          sx={{
            color: block.dark ? "dark" : "light",
            textTransform: "uppercase",
            fontSize: [1, 2, "16px"],
            fontWeight: 500,
            "& ul": {
              listStyle: "none",
              padding: 0,
              display: "grid",

              gridTemplateColumns: ["1fr", "1fr", "1fr 1fr"],
              "& li": {
                width: "100%",
                height: "100%",
                position: "relative",
                paddingLeft: "60px",
                display: "flex",
                alignItems: "center",
                alignContent: "center",
                my: 2,
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  top: "50%",

                  width: "100%",
                  height: "20px",
                  backgroundImage:
                    block.dark && !isDark
                      ? `url(${ArrowPrimary})`
                      : block.dark && isDark
                      ? `url(${ArrowWhite})`
                      : isDark
                      ? `url(${ArrowPrimary})`
                      : `url(${ArrowWhite})`,
                  backgroundRepeat: "no-repeat",
                  transform: "translateY(-50%)",
                },
              },
            },
          }}
          dangerouslySetInnerHTML={{ __html: block.list }}
        />
      </Grid>
    </Container>
  )
}

export default ListCollection
